import { makeRequest } from '../../../api/makeRequest';

export const deactivateFamily = (ctn) => makeRequest({
  url: '/limitFamily/deactivateByChild/',
  method: 'post',
  params: {
    parentCtn: ctn,
  },
  headers: {
    'X-Requested-With': 'XMLHttpRequest',
  },
});
